<div
  [ngClass]="{
    'justify-flex-end': this.section?.config?.theme === sectionThemes.IMAGE
  }"
  class="[ m-be-0 ]"
>
  <div *ngIf="section.config.headerTitle" class="[ relative index-surface ]">
    <div class="header [ flex justify-center items-center relative ] [ corner-full icon-size-3xl title-large ]">
      <img *ngIf="section.config.imageUrl" [src]="section.config.imageUrl | assetsPath: 'icons':'educontent'" />
      <span *ngIf="!section.config.imageUrl" [innerHTML]="section.config.headerTitle | safeHtml"> </span>
    </div>
    <div
      *ngIf="section.config.theme === sectionThemes.SCHEURBLOK"
      class="[ imposter ] [ left-full w-full ] [ border-be border-be-dashed ] [ index-pullback ]"
    ></div>
  </div>
  <campus-edu-content-result-loader
    #eduContentPendingResult
    *ngFor="let sectionContent of section.sectionContents"
    [eduContentId]="sectionContent.eduContent.id"
  >
    <div
      class="[ max-w-min ] [ index-surface ]"
      [ngClass]="{ 
        '[ w-2/12 ]': sectionContent.eduContent?.isScorable,
        '[ filter blur-2xs grayscale-100 pointer-event-none ]': eduContentPendingResult.eduContentResultPending$ | async,
      }"
    >
      <ng-container *ngIf="section.config.theme !== sectionThemes.MEDIA; else showMedia">
        <div *ngIf="sectionContent.actions.length === 1">
          <button outline-button (click)="onEduContentClick(sectionContent, { source: 'button' })">
            <ng-container *ngIf="section.config.theme !== sectionThemes.IMAGE; else isImage">
              <span class="[ weight-bold headline-small ]">
                {{ sectionContent.eduContent.publishedEduContentMetadata.shortTitle }}
              </span>
            </ng-container>
            <ng-template #isImage>
              <img [src]="section.config?.imageUrl | assetsPath: 'images':'illustrations'" class="section-image" />
            </ng-template>

            <ng-container
              *ngIf="section.config.theme !== sectionThemes.IMAGE && sectionContent?.actions?.[0] as action"
            >
              <div
                *ngIf="action?.showAsBadge"
                class="badge [ absolute top-0 right-none -m-xs ] [ flex items-center justify-center ] [ border corner-full elevation-3 p-3xs ]"
              >
                <dcr-icon class="tileBadge" [icon]="'shared:' + action.icon"></dcr-icon>
              </div>
            </ng-container>

            <div *ngIf="section.config?.footerIcon" class="section-level [ absolute inset-be-none inset-i-none ]">
              <div class="[ imposter center-content ] [ w-10/12 overflow-visible ]">
                <campus-svg [svgImage]="section.config.footerIcon" class="[ fill-current ]"></campus-svg>
              </div>
            </div>
          </button>
        </div>
        <div *ngIf="sectionContent.actions.length >= 2" class="relative">
          <button outline-button [attr.id]="'ecls-trigger-' + sectionContent.eduContent.id">
            <ng-container *ngIf="section.config.theme !== sectionThemes.IMAGE; else isImage">
              <span class="[ weight-bold headline-small ]">
                {{ sectionContent.eduContent.publishedEduContentMetadata.shortTitle }}
              </span>
            </ng-container>
            <ng-template #isImage>
              <img [src]="section.config?.imageUrl | assetsPath: 'images':'illustrations'" class="section-image" />
            </ng-template>

            <ng-container
              *ngIf="section.config.theme !== sectionThemes.IMAGE && sectionContent?.actions?.[0] as action"
            >
              <div
                *ngIf="action?.showAsBadge"
                class="badge [ absolute top-0 right-none -m-xs ] [ flex items-center justify-center ] [ border corner-full elevation-3 p-3xs ]"
              >
                <dcr-icon class="tileBadge" icon="shared:dots"></dcr-icon>
              </div>
            </ng-container>

            <div *ngIf="section.config?.footerIcon" class="section-level [ absolute inset-be-none inset-i-none ]">
              <div class="[ imposter center-content ] [ w-10/12 overflow-visible ]">
                <campus-svg [svgImage]="section.config.footerIcon" class="[ fill-current ]"></campus-svg>
              </div>
            </div>
          </button>

          <dcr-menu
            [anchor]="'ecls-trigger-' + sectionContent.eduContent.id"
            positioning="popover"
            anchor-corner="start-end"
            menu-corner="end-end"
          >
            <dcr-menu-item
              *ngFor="let action of sectionContent?.actions"
              [label]="action.label"
              [attr.leading-icon]="'shared:' + action.icon"
              (click)="onEduContentClick(sectionContent, { action })"
            ></dcr-menu-item>
          </dcr-menu>
        </div>

        <div
          *ngIf="section.config.theme === sectionThemes.SCHEURBLOK"
          class="[ imposter ] [ left-full w-full ] [ border-be border-be-dashed ] [ index-pullback ]"
        ></div>
        <campus-rating
          class="[ white-space-nowrap ] rating"
          [ngClass]="{
            '[ m-bs-xs ]': section.config?.footerIcon,
            '[ absolute -bottom-m ]': !section.config?.footerIcon,
            '[ grayscale opacity-low ]': !sectionContent.isFinished
          }"
          *ngIf="sectionContent.eduContent.isScorable"
          [total]="3"
          [count]="sectionContent.stars"
        ></campus-rating>
      </ng-container>
      <ng-template #showMedia>
        <button
          outline-button
          (click)="onEduContentClick(sectionContent)"
          [leadingIcon]="sectionContent.eduContent?.icon"
        >
          {{ sectionContent.eduContent?.name }}
        </button>
      </ng-template>
    </div>
  </campus-edu-content-result-loader>
</div>
